import { observable, action, makeObservable, computed } from "mobx";
import { Countries } from "../helpers/agent";

class CountriesStore {
  loadingCount = 0;
  countriesRegistry = undefined;

  constructor() {
    makeObservable(this, {
      loadingCount: observable,
      countriesRegistry: observable,
      loading: computed,
      countries: computed,
      loadCountries: action,
    });
  }

  get loading() {
    return this.loadingCount > 0;
  }

  get countries() {
    return Array.isArray(this.countriesRegistry) ? this.countriesRegistry : [];
  }

  loadCountries({ acceptCached = true } = {}) {
    console.log('🌍 CountriesStore.loadCountries called', {
      acceptCached,
      currentRegistry: this.countriesRegistry,
      registryType: typeof this.countriesRegistry,
      isArray: Array.isArray(this.countriesRegistry)
    });

    if (acceptCached) {
      if (this.countriesRegistry?.length) {
        return Promise.resolve(this.countriesRegistry);
      }
    }

    console.log('🌍 Loading countries from API...');
    this.loadingCount++;

    return Countries.list()
      .then(
        action((countries) => {
          console.log('🌍 API Response received:', {
            countries,
            type: typeof countries,
            isArray: Array.isArray(countries),
            length: countries?.length
          });
          this.countriesRegistry = countries;
          return this.countriesRegistry;
        })
      )
      .catch(
        action((err) => {
          console.error('🌍 Countries API failed:', err);
          console.error('🌍 Error details:', {
            status: err?.response?.status,
            statusText: err?.response?.statusText,
            body: err?.response?.body,
            message: err?.message
          });
          this.countriesRegistry = [];
          return [];
        })
      )
      .finally(
        action(() => {
          this.loadingCount--;
        })
      );
  }
}

const CountriesStoreInstance = new CountriesStore();
export default CountriesStoreInstance;
